import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { get } from 'lodash';
import { Home as HomeIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import useActiveUser from '../../../../hooks/useActiveUser';
import useRescuerDashboardActions from '../../../../hooks/useRescuerDashboardActions';
import { userBadges } from '../../rescuerDashboardDesktop/myFrus/Components/MyBadges';
import routes from '../../../../routes';
import { StyledRescuerBreadcrumb, StyledRescuerTextBreadcrumb } from '../Components/StyledRescuerBreadcrumb';

const BadgesBreadcrumb = () => (
  <Box boxShadow={0}>
    <Breadcrumbs aria-label="breadcrumb">
      <StyledRescuerBreadcrumb
        component={RouterLink}
        to={routes.index}
        label="Home"
        icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
      />
      <StyledRescuerTextBreadcrumb component="a" href="#" label="My badges" />
    </Breadcrumbs>
  </Box>
);

const BadgesDashboardMobileContainer = () => {
  const activeUser = useActiveUser();
  const badgesEntities = useSelector((state) => state.entities.badges);
  const badgesList = get(badgesEntities, `byRescuerId[${activeUser.id}].badges`, []);
  const badgesLoading = get(badgesEntities, `inflight`, true);
  const { fetchMyBadges } = useRescuerDashboardActions();

  useEffect(() => {
    fetchMyBadges(false, false); //quietMode, force
  }, [activeUser.id, fetchMyBadges]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const jsx = userBadges(badgesList);

  if (!badgesLoading && badgesList.length === 0) {
    return (
      <>
        <BadgesBreadcrumb />
        <Box sx={{ py: 2 }}>
          <Box
            sx={{
              position: 'relative',
              height: '100%',
              width: '100%',
              overflow: 'auto',
              backgroundColor: 'background.default',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                WebkitTransform: 'translate(-50%, -50%)',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
              }}
            >
              <Typography color="textSecondary" variant="h5">
                Loading badges...
              </Typography>
            </Box>
          </Box>
        </Box>
      </>
    );
  }

  return (
    <>
      <BadgesBreadcrumb />
      <Box sx={{ py: 2 }}>
        <Box
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
          columnGap="16px"
          rowGap="5px"
          px="5px"
          overflow="scroll"
        >
          <Typography color="textSecondary" variant="body2">
            Badges are awarded based on the number of closed rescues.
          </Typography>
          {jsx}
        </Box>
      </Box>
    </>
  );
};

export default BadgesDashboardMobileContainer;
